<template>
  <div class="left-guid">
    <div class="user-info">
      <el-badge
        class="user-rank"
        is-dot
        :rank-level="$store.state.userInfo.vipType > 0 ? 1 : 0"
      >
        <el-upload
          class="avatar-uploader"
          :action="uplodAction"
          :show-file-list="false"
          :headers="uplodHeaders"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          ref="avatarUploader"
        >
          <el-avatar
            style="height: 85px; width: 85px"
            class="user-avatar"
            v-if="$store.state.userInfo.headPhoto"
            :src="$store.state.userInfo.headPhoto"
          ></el-avatar>
          <el-avatar class="user-avatar" v-else :src="avatarUrl"></el-avatar>
        </el-upload>
        <!-- <el-avatar class="user-avatar" :src="avatarUrl"></el-avatar> -->
      </el-badge>
      <div class="name">{{ $store.state.userInfo.username }}</div>
      <div class="info">
        <span>
          ID:
          <template>{{ $store.state.userInfo.id }}</template>
        </span>
        <span>
          积分:
          <template>{{ $store.state.userInfo.integral || 0 }}</template>
        </span>
        <span v-if="$store.state.userInfo.vipType > 0">
          {{ "今日免费积分：" + $store.state.userInfo.freeIntegral }}
        </span>
        <span v-if="$store.state.userInfo.vipType > 0">
          {{
            ($store.state.userInfo.vipType === 1 ? "VIP" : "SVIP") +
            "到期时间：" +
            ($store.state.userInfo.vipTime
              ? dateFormat($store.state.userInfo.vipTime, "YYYY-MM-DD")
              : "永久有效")
          }}
        </span>
      </div>
    </div>

    <!-- <el-menu router :default-active="menuActive"> -->
    <el-menu :default-active="menuActive" @select="handleMenuSelect">
      <!-- <el-menu-item index="/user/collect">
        <svg
          t="1653550300495"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1751"
          width="64"
          height="64"
        >
          <path
            d="M517.89889355 672.14217411c-69.12795966 0-129.87677391-31.42179956-163.39335982-56.55924012-18.85308003-14.66350735-20.94786639-41.89573277-6.2843605-58.65402644 14.66350735-18.85308003 41.89573277-20.94786639 58.65402644-6.28436051 4.18957267 4.18957267 108.92890754 83.791467 207.38388042 0 16.7582937-14.66350735 43.99052059-12.56871953 58.65402645 4.18957268 14.66350735 16.7582937 12.56871953 43.99052059-4.18957268 58.65402794-48.18009327 43.99052059-102.64454703 58.65402644-150.82464031 58.65402645z"
            p-id="1752"
          ></path>
          <path
            d="M777.65243992 984.2653879c-8.37914686 0-18.85308003-2.09478635-27.23222541-6.28436051L511.61453306 881.62084087l-238.80567999 96.36018652c-23.04265273 10.47393318-50.27487962 6.2843605-69.12795965-8.37914684-20.94786639-14.66350735-31.42179956-37.70616007-29.3270147-62.84359914l18.85308006-257.6587615-165.48814621-196.90994723c-16.7582937-18.85308003-20.94786639-46.08530691-12.56871952-69.12795964 8.37914686-23.04265273 27.23222688-41.89573277 52.36966595-48.18009324l249.27961465-62.84360063 136.16113295-217.8578136c12.56871953-20.94786639 35.61137374-33.51658738 60.7488128-33.51658591s48.18009327 12.56871953 60.74881427 33.51658591l136.16113294 217.8578136 249.27961464 62.84360063c25.13744054 6.2843605 43.99052059 23.04265273 52.36966596 48.18009324 8.37914686 23.04265273 2.09478635 50.27487962-12.56871953 69.12795964l-165.48814766 196.90994723 18.85308006 257.6587615c2.09478635 25.13744054-8.37914686 48.18009327-29.32701325 62.84359914-14.66350735 10.47393318-29.32701323 14.66350735-46.08530691 14.66350735z m-266.03790686-188.53080037c6.2843605 0 10.47393318 0 16.75829368 2.09478633l236.71089365 96.36018653-18.85308005-255.56397367c0-10.47393318 2.09478635-20.94786639 10.4739332-29.32701323l165.48814765-196.90994722-249.27961465-62.84359913c-10.47393318-2.09478635-18.85308003-8.37914686-25.13743907-18.85308006L511.61453306 114.92891985l-136.16113295 217.8578136c-6.2843605 8.37914686-14.66350735 16.7582937-25.13744053 18.85308002l-249.27961319 62.84359916 165.48814618 196.90994721c6.2843605 8.37914686 10.47393318 18.85308003 10.47393319 29.32701323l-18.85308005 255.56397514 236.71089363-96.36018799c6.2843605-4.18957267 12.56871953-4.18957267 16.75829372-4.18957269z"
            p-id="1753"
          ></path>
        </svg>
        <span slot="title">我的收藏</span>
      </el-menu-item> -->
      <el-menu-item index="/user/jifen">
        <svg
          t="1653550343573"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1900"
          width="64"
          height="64"
        >
          <path
            d="M936.19430083 700.53080036a47.1327001 47.1327001 0 0 1 47.1327001 47.13270012c0 140.59684437-213.88819302 235.66350048-471.32700093 235.66350045S40.67299907 888.26034484 40.67299907 747.66350048a47.1327001 47.1327001 0 0 1 93.93547129-5.51452592L134.93839925 747.66350048c0 67.63542463 165.90710432 141.39810029 377.06160075 141.39810027 206.29982832 0 369.52036874-70.41625394 376.82593725-136.77909568L889.06160075 747.66350048a47.1327001 47.1327001 0 0 1 47.13270008-47.13270012z m0-235.66350046a47.1327001 47.1327001 0 0 1 47.1327001 47.1327001c0 140.59684437-213.88819302 235.66350048-471.32700093 235.66350048S40.67299907 652.59684437 40.67299907 512a47.1327001 47.1327001 0 0 1 93.93547129-5.51452591L134.93839925 512c0 67.63542463 165.90710432 141.39810029 377.06160075 141.39810029 206.29982832 0 369.52036874-70.41625394 376.82593725-136.77909568L889.06160075 512a47.1327001 47.1327001 0 0 1 47.13270008-47.1327001z m-424.19430083-424.19430083c257.4388079 0 471.32700093 95.0666561 471.32700093 235.66350045s-213.88819302 235.66350048-471.32700093 235.66350048-471.32700093-95.0666561-471.32700093-235.66350048 213.88819302-235.66350048 471.32700093-235.66350045z m0 94.26540018c-211.15449641 0-377.06160075 73.76267565-377.06160075 141.39810027s165.90710432 141.39810029 377.06160075 141.39810029 377.06160075-73.76267565 377.06160075-141.39810029-165.90710432-141.39810029-377.06160075-141.39810027z"
            p-id="1901"
          ></path>
        </svg>
        <span slot="title">我的积分</span>
      </el-menu-item>
      <el-menu-item index="/user/download">
        <svg
          t="1653550379011"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2054"
          width="64"
          height="64"
        >
          <path
            d="M867.99802469 440.80039506H725.59881482V13.60276543H298.40118518v427.19762963H156.00197531l355.99802469 355.99802469 355.99802469-355.99802469z m-498.39723456 71.19960494V84.80237037h284.79841974v427.19762963h41.68413235L512 696.08334222 327.91665778 512H369.60079013z"
            p-id="2055"
          ></path>
          <path
            d="M927.1584237 725.59881482H867.99802469v142.39920987c0 39.22450963-31.97509531 71.19960494-71.19960494 71.19960494H227.20158025c-39.22450963 0-71.19960494-31.97509531-71.19960494-71.19960494V725.59881482h-71.19960494v142.39920987c0 78.31956543 64.07964445 142.39920987 142.39920988 142.39920988h569.5968395c78.31956543 0 142.39920987-64.07964445 142.39920988-142.39920988V737.63802075c0-6.60214518-5.43706075-12.03920592-12.03920593-12.03920593z"
            p-id="2056"
          ></path>
        </svg>
        <span slot="title">我的下载</span>
      </el-menu-item>
      <!-- <el-menu-item index="/user/upload">
        <svg
          t="1653550397397"
          viewBox="0 0 1051 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2209"
          width="64"
          height="64"
        >
          <path
            d="M524.95099812 686.98366625a40.42105219 40.42105219 0 0 0 40.30490063-40.30490063V155.23775l169.00181437 169.00181437a41.23411969 41.23411969 0 0 0 56.91470063 0 40.30490063 40.30490063 0 0 0 0-56.91470062L577.91651563 53.72050812a74.33756813 74.33756813 0 0 0-104.53720501 1e-8L258.845735 267.32486375a40.18874813 40.18874813 0 0 0 56.91470063 56.91470063L484.994555 155.23775v491.44101563a40.30490063 40.30490063 0 0 0 39.95644313 40.30490062z"
            p-id="2210"
          ></path>
          <path
            d="M841.93103469 141.76406563a40.30490063 40.30490063 0 1 0 0 80.49364781A95.70961875 95.70961875 0 0 1 937.98911094 317.85117969v498.06170625a95.70961875 95.70961875 0 0 1-95.59346625 95.59346625H208.08711406a95.70961875 95.70961875 0 0 1-95.59346625-95.59346625V317.85117969a95.70961875 95.70961875 0 0 1 95.59346625-95.59346625 40.30490063 40.30490063 0 0 0 0-80.49364782A176.31941906 176.31941906 0 0 0 32 317.85117969v498.06170625a176.31941906 176.31941906 0 0 0 176.08711406 176.08711406h633.84392063a176.31941906 176.31941906 0 0 0 176.08711406-176.08711406V317.85117969A176.31941906 176.31941906 0 0 0 841.93103469 141.76406563z"
            p-id="2211"
          ></path>
        </svg>
        <span slot="title">我的上传</span>
      </el-menu-item> -->
      <el-menu-item index="/user/vip">
        <svg
          t="1653550410309"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2364"
          width="64"
          height="64"
        >
          <path
            d="M561.71026963 133.50290015a77.6722963 77.6722963 0 0 1 9.96794429 9.96794429L719.12612386 320.40833539l162.64578845-120.10726042a77.6722963 77.6722963 0 0 1 121.50536177 81.29700386L848.57995022 900.36148148H175.42004978L20.72272592 281.62396918a77.6722963 77.6722963 0 0 1 121.50536177-81.32289421L304.87387614 320.40833539l147.44790994-176.93749095a77.6722963 77.6722963 0 0 1 109.41437391-9.96794429zM512 193.18111406l-194.33608533 233.22401542-221.57317098-163.62963793L236.05622162 822.68918518h551.88755676l139.96547793-559.91369363-221.57317098 163.62963793L512 193.18111406z m181.23535762 486.22857483v82.85044978H330.76464238v-82.85044978h362.47071524z"
            p-id="2365"
          ></path>
        </svg>
        <span slot="title">我的VIP</span>
      </el-menu-item>
      <el-menu-item index="/user/order">
        <svg
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          data-v-78e17ca8=""
        >
          <path
            fill="currentColor"
            d="M704 192h160v736H160V192h160v64h384v-64zM288 512h448v-64H288v64zm0 256h448v-64H288v64zm96-576V96h256v96H384z"
          ></path>
        </svg>
        <span slot="title">我的订单</span>
      </el-menu-item>
      <hr />

      <el-menu-item index="ssoUserCenter">
        <svg
          t="1653550420401"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2518"
          width="64"
          height="64"
        >
          <path
            d="M111.50222222 38.68444445h282.96988445a72.81777778 72.81777778 0 0 1 67.10158222 44.49166222l41.03281778 97.21173333a36.40888889 36.40888889 0 0 0 33.53258666 22.20942222H912.49777778a72.81777778 72.81777778 0 0 1 72.81777777 72.81777778V912.49777778a72.81777778 72.81777778 0 0 1-72.81777777 72.81777777H111.50222222a72.81777778 72.81777778 0 0 1-72.81777777-72.81777777V111.50222222a72.81777778 72.81777778 0 0 1 72.81777777-72.81777777z m0 72.81777777v800.99555556h800.99555556V275.45144889H536.13909333A109.22666667 109.22666667 0 0 1 435.54133333 208.71395555L394.47210667 111.50222222H111.50222222z"
            p-id="2519"
          ></path>
          <path
            d="M293.54666667 657.63555555m36.40888888 0l364.0888889 0q36.40888889 0 36.40888888 36.4088889l0 0q0 36.40888889-36.40888888 36.40888888l-364.0888889 0q-36.40888889 0-36.40888888-36.40888888l0 0q0-36.40888889 36.40888888-36.4088889Z"
            p-id="2520"
          ></path>
        </svg>
        <span slot="title">个人资料</span>
      </el-menu-item>
      <!-- <el-menu-item index="/user/info">
        <svg
          t="1653550420401"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2518"
          width="64"
          height="64"
        >
          <path
            d="M111.50222222 38.68444445h282.96988445a72.81777778 72.81777778 0 0 1 67.10158222 44.49166222l41.03281778 97.21173333a36.40888889 36.40888889 0 0 0 33.53258666 22.20942222H912.49777778a72.81777778 72.81777778 0 0 1 72.81777777 72.81777778V912.49777778a72.81777778 72.81777778 0 0 1-72.81777777 72.81777777H111.50222222a72.81777778 72.81777778 0 0 1-72.81777777-72.81777777V111.50222222a72.81777778 72.81777778 0 0 1 72.81777777-72.81777777z m0 72.81777777v800.99555556h800.99555556V275.45144889H536.13909333A109.22666667 109.22666667 0 0 1 435.54133333 208.71395555L394.47210667 111.50222222H111.50222222z"
            p-id="2519"
          ></path>
          <path
            d="M293.54666667 657.63555555m36.40888888 0l364.0888889 0q36.40888889 0 36.40888888 36.4088889l0 0q0 36.40888889-36.40888888 36.40888888l-364.0888889 0q-36.40888889 0-36.40888888-36.40888888l0 0q0-36.40888889 36.40888888-36.4088889Z"
            p-id="2520"
          ></path>
        </svg>
        <span slot="title">个人资料</span>
      </el-menu-item>
      <el-menu-item index="/user/password">
        <svg
          t="1653550429690"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2673"
          width="64"
          height="64"
        >
          <path
            d="M512 31.40266667c168.90811733 0 305.83466667 136.92654933 305.83466667 305.83466666v65.536a131.072 131.072 0 0 1 131.072 131.072v327.68a131.072 131.072 0 0 1-131.072 131.072H206.16533333a131.072 131.072 0 0 1-131.072-131.072V533.84533333a131.072 131.072 0 0 1 131.072-131.072v-65.536c0-168.90811733 136.92654933-305.83466667 305.83466667-305.83466666z m305.83466667 436.90666666H206.16533333a65.536 65.536 0 0 0-65.42677333 61.69122134L140.62933333 533.84533333v327.68a65.536 65.536 0 0 0 61.69122134 65.42677334L206.16533333 927.06133333h611.66933334a65.536 65.536 0 0 0 65.42677333-61.69122133L883.37066667 861.52533333V533.84533333a65.536 65.536 0 0 0-61.69122134-65.42677333L817.83466667 468.30933333z m-185.68533334 196.608a32.768 32.768 0 0 1 0 65.536h-240.29866666a32.768 32.768 0 0 1 0-65.536h240.29866666zM512 96.93866667c-130.613248 0-236.86894933 104.20224-240.21128533 234.00721066L271.70133333 337.23733333v65.536h480.59733334v-65.536c0-130.613248-104.20224-236.86894933-234.00721067-240.21128533L512 96.93866667z"
            p-id="2674"
          ></path>
        </svg>
        <span slot="title">修改密码</span>
      </el-menu-item>
      <el-menu-item index="/user/email">
        <svg
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          data-v-78e17ca8=""
        >
          <path
            fill="currentColor"
            d="M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224H128zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64z"
          ></path>
          <path
            fill="currentColor"
            d="M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224h784zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224H205.056z"
          ></path>
        </svg>
        <span slot="title">我的邮箱</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import { redirectSSOUserProfile } from "../../util/utils";

export default {
  data() {
    return {
      avatarUrl: require("@/assets/images/avatar-default.png"),
      uplodAction: `${process.env.VUE_APP_BASE_API}/user/upload-avatar`,
      uplodHeaders: {
        authorization: "Bearer " + localStorage.getItem("token"),
        "x-authorization": "Bearer " + localStorage.getItem("refreshToken"),
      },
    };
  },
  props: {
    menuActive: {
      type: String,
      default: "1",
    },
  },
  methods: {
    handleMenuSelect(index) {
      if (index === "ssoUserCenter") {
        redirectSSOUserProfile();
      } else {
        this.$router.push({ path: index });
      }
    },
    updateUplodHeaders() {
      this.uplodHeaders = {
        authorization: "Bearer " + localStorage.getItem("token"),
        "x-authorization": "Bearer " + localStorage.getItem("refreshToken"),
      };
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";

      return moment(cellValue).format(format);
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        // this.user.HeadPhoto = URL.createObjectURL(file.raw);
        this.getUserInformation();
      } else {
        this.$message.error(res.errors);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png|jpg|jepg 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      }
    },
    /**获取登录用户信息 */
    getUserInformation() {
      axiosRequest(
        "/user/user-formation",
        { t: Date.now() },
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data && res.data.code == 200) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          // userInfo.id = res.data.data.id;
          // userInfo.username = res.data.data.username;
          userInfo.headPhoto = res.data.data.headPhotoUrl;
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.$store.commit("setUserInfo", userInfo);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";

::v-deep .user-info {
  padding-top: 32px;
}
</style>
<style>
.el-avatar > img {
  width: 100%;
  height: 100%;
}
</style>
